import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { AppRoutesEnum } from './enums/app-routes.enum';
import { PermissionsResolver } from './services/resolvers/permissions.resolver';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { ErrorComponent } from './errors/error/error.component';
import { AccessDeniedComponent } from './errors/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: AppRoutesEnum.Investigations,
        pathMatch: 'full',
      },
      {
        path: AppRoutesEnum.NotFound,
        component: NotFoundComponent,
      },
      {
        path: AppRoutesEnum.Error,
        component: ErrorComponent,
      },
      {
        path: AppRoutesEnum.Investigations,
        canActivate: [
          AuthGuard,
        ],
        loadChildren: () => import('./pages/investigations/investigations.module').then(m => m.InvestigationsModule),
      },
      {
        path: AppRoutesEnum.PolicySettings,
        canActivate: [
          AuthGuard,
        ],
        loadChildren: () => import('./pages/policy-settings/policy-settings.module').then(m => m.PolicySettingsModule),
      },
      {
        path: AppRoutesEnum.Organization,
        canActivate: [
          AuthGuard,
        ],
        loadChildren: () => import('./pages/organization/organization.module').then(m => m.OrganizationModule),
      },
      {
        path: AppRoutesEnum.UsersManagement,
        canActivate: [
          AuthGuard,
        ],
        loadChildren: () => import('./pages/users-management/users-management.module').then(m => m.UsersManagementModule),
      },
      {
        path: AppRoutesEnum.AccessDenied,
        component: AccessDeniedComponent,
      },
    ],
    resolve: {
      permissions: PermissionsResolver,
    },
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '**',
    redirectTo: AppRoutesEnum.NotFound,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
